import styled from '@emotion/styled';
import Typography from '@material-ui/core/Typography';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

const LatestProjectEmptyState: FC = () => (
  <Root>
    <EmptyMessage variant="subtitle1">
      <FormattedMessage id="latest_insights_page.no_project_created" />
    </EmptyMessage>
  </Root>
);

const Root = styled('div')({});

const EmptyMessage = styled(Typography)({
  fontWeight: 'normal',
});

export default LatestProjectEmptyState;
